import React from 'react';

const LinkWithClickHandler = ({ onClick, link = '', children, tabIndex = -1, classNames, ariaLabel = '' }) => {
  return (
    <button
      onClick={() => onClick(link)}
      tabIndex={tabIndex}
      className={`link cursor-pointer font-medium underline ${classNames}`}
      aria-label={ariaLabel}
    >
      {children}
    </button>
  );
};

export default LinkWithClickHandler;
